import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useVerticalExternalTimelineProcessController, } from "../../../useVerticalTimelineProcessController";
import { InfoExams } from "./components/InfoExams";
import { TimelineDescriptionDotFinishedDefault } from "../TimelineDescriptionDotProcess/components/TimelineDescriptionDotFinishedDefault";
import { TimelineDescriptionDotExamResult } from "./components/TimelineDescriptionDotExamResult";
export function TimelineDescriptionDotExam(_a) {
    var data = _a.data, step = _a.step;
    var _b = useVerticalExternalTimelineProcessController({
        data: data,
    }), mustDisplayLocalExams = _b.mustDisplayLocalExams, isAttrDateNull = _b.isAttrDateNull;
    var examType = step.key === "Avaliação Psicológica" ? "P" : "M";
    if (mustDisplayLocalExams(step.key))
        return (_jsx(InfoExams, { equitableDistribution: data.distribuicaoEquitativa, type: examType }));
    if (isAttrDateNull(step.key))
        return _jsx(_Fragment, {});
    return (_jsxs(_Fragment, { children: [_jsx(TimelineDescriptionDotFinishedDefault, { data: data, step: step }), _jsx(TimelineDescriptionDotExamResult, { data: data, step: step })] }));
}
